<script module lang="ts">
  export type { ThresholdRange, ThresholdRanges } from "@/libs/ui/IlluminationCompass/thresholds"
</script>

<script lang="ts">
  import type { ComponentProps } from "svelte"
  import { getFeaturesStore } from "@/libs/feature-toggle/store.svelte"

  type CompassBackModule =
    typeof import("./IlluminationCompassBackV1/IlluminationCompassBack.svelte")

  const featuresStore = getFeaturesStore()

  let props: ComponentProps<CompassBackModule["default"]> = $props()
  let shouldUseV2 = $derived(
    featuresStore?.isReady && featuresStore.features.isOn("new-illumination-compass"),
  )

  let compassBack = $derived(
    (shouldUseV2
      ? import("./IlluminationCompassBackV2/IlluminationCompassBack.svelte")
      : import(
          "./IlluminationCompassBackV1/IlluminationCompassBack.svelte"
        )) as Promise<CompassBackModule>,
  )
</script>

{#await compassBack then Module}
  <Module.default {...props} />
{/await}
